import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@pwc/pwc-deals-ui';
import './SharedPill.scss';

const SharedPill = ({ hideTextVersion, shared, version }) => {
  const { t } = useTranslation();
  const versionText = hideTextVersion
    ? t('draftShared')
    : t('versionDraftShared', { version });

  return (
    <>
      {(shared || version) && (
        <div className="shared-pill" data-testid="shared-with-client-pill">
          <Icon name="view" width={16} className="fill icon-black" />
          <span className="text-shared-with-client">
            {versionText}
            <span className="hide-for-mobile">{t('withClient')}</span>
          </span>
        </div>
      )}
    </>
  );
};

export default SharedPill;
